export default __webpack_public_path__ + "static/char-s-54-ja-9d32567eebddcb31bf7eeb7534cdb8dc.webp";